import {
  Box,
  Button,
  Flex,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import Layout from "../components/Layout";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "../utils/client";
import EventItem from "../components/EventItem";
import { useAuth } from "../context/AuthContext";
import AdminPage from "../components/AdminPage";

const AllEvents = () => {
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [eventsItems, setEventsItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState([]);
  const [reload, setReload] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();

  const isAdmin = auth?.user?.type === process.env.REACT_APP_ADMINISTRATOR;

  useEffect(() => {
    setIsLoadingPage(true);
    const request = async () => {
      const response = await client.get(`/events?page=${currentPage}`);
      setEventsItems(response.data.eventItems);
      setCurrentPage(response.data.currentPage);
      setTotalPages(
        Array.from({ length: response.data.totalPages }, (_, index) => index + 1)
      );
    };
    request().then(() => setIsLoadingPage(false));
  }, [currentPage, reload, auth.user.token]);

  const handleDelete = async (eventId) => {
    await client.delete(`/events/${eventId}`);
    setEventsItems(eventsItems.filter((event) => event.eventId !== eventId));
    setReload(!reload);
  };

  return (
    <Layout>
      <AdminPage
        title="Gerenciar Eventos"
        subtitle={`${eventsItems.length} eventos`}
        action={isAdmin ? () => navigate("/createEvent") : undefined}
        actionLabel="+ Novo Evento"
      >
        <Skeleton isLoaded={!isLoadingPage}>
          <TableContainer>
            <Table size="sm" variant="striped" colorScheme="green" fontSize="0.82rem">
              <Thead bg="green.50">
                <Tr>
                  <Th fontSize="0.72rem" maxW="200px">Evento</Th>
                  <Th fontSize="0.72rem">Data</Th>
                  <Th fontSize="0.72rem">Palestrantes</Th>
                  <Th fontSize="0.72rem">Ouvintes</Th>
                  <Th fontSize="0.72rem">Ações</Th>
                </Tr>
              </Thead>
              <Tbody>
                {eventsItems?.length === 0 && !isLoadingPage && (
                  <tr>
                    <td colSpan={5}>
                      <Box textAlign="center" py={8} color="gray.400">
                        <Text>Nenhum evento encontrado.</Text>
                      </Box>
                    </td>
                  </tr>
                )}
                {eventsItems?.[0]?.eventId &&
                  eventsItems.map((event) => (
                    <EventItem key={event.eventId} onDelete={handleDelete} event={event} />
                  ))}
              </Tbody>
            </Table>
          </TableContainer>

          {totalPages.length > 1 && (
            <Flex gap={2} py={4} px={5} alignItems="center" justifyContent="center">
              {totalPages.map((page) =>
                page === currentPage ? (
                  <Box key={page} w="32px" h="32px" borderRadius="50%" bg="green.500" color="white" display="flex" alignItems="center" justifyContent="center" fontWeight={700} fontSize="0.85rem">{page}</Box>
                ) : (
                  <Button key={page} colorScheme="green" size="sm" variant="outline" borderRadius="50%" w="32px" h="32px" p={0} onClick={() => setCurrentPage(page)}>{page}</Button>
                )
              )}
            </Flex>
          )}
        </Skeleton>
      </AdminPage>
    </Layout>
  );
};
export default AllEvents;
